/*
*   Create a component custom to save product grid layout in mobile
*/

class GridToggle extends HTMLElement {
    connectedCallback() {
        this.init();
    }

    getCanonicalId(inputId) {
        if (inputId && inputId.indexOf('grid-mobile') === 0) {
            return 'grid-mobile';
        }

        return 'column-mobile';
    }

    getComponentInputByCanonicalId(canonicalId) {
        const inlineInput = this.querySelector(`#${canonicalId}-ui`);
        if (inlineInput) {
            return inlineInput;
        }

        return this.querySelector(`#${canonicalId}`);
    }

    syncStateInputs(canonicalId) {
        const stateInput = document.getElementById(canonicalId);
        if (stateInput) {
            stateInput.checked = true;
        }
    }

    init() {
        const inputs = this.querySelectorAll('input[name="plp-grid-btn"]');

        // Restore last selected layout; cookie stores canonical ids.
        const savedValue = CookieUtils.getCookie('plp-grid-btn');
        const canonicalSavedValue = this.getCanonicalId(savedValue);

        const savedInput = this.getComponentInputByCanonicalId(canonicalSavedValue);
        if (savedInput) {
            savedInput.checked = true;
        }
        this.syncStateInputs(canonicalSavedValue);

        // Keep cookie and hidden state inputs in sync.
        inputs.forEach(input => {
            input.addEventListener('change', () => {
                const canonicalId = this.getCanonicalId(input.id);
                CookieUtils.setCookie('plp-grid-btn', canonicalId, 7);
                this.syncStateInputs(canonicalId);
            });
        });
    }
}

if (!customElements.get('grid-toggle')) {
    customElements.define('grid-toggle', GridToggle);
}